export default "/kiban/_next/static/images/04_harness-87c58edcb4e9cc9da633dc61aa24f3d3.png";